import { type Enum } from '@webapp/infrastructure/types/Enum'

export const OrderDraftItemMutationStatuses = {
  CREATING: 'creating',
  FAILED_TO_CREATE: 'failed-to-create',
  UPDATING: 'updating',
  FAILED_TO_UPDATE: 'failed-to-update',
  DELETING: 'deleting',
  FAILED_TO_DELETE: 'failed-to-delete',
  COMPLETED: 'completed',
} as const

export type OrderDraftItemMutationStatusEnum = Enum<
  typeof OrderDraftItemMutationStatuses
>
